const ENVs = {
    development: {
        // SERVER_URL: "https://api.menusifudev.com",
        SERVER_URL: "https://auth.menusifudev.com/api",
        PLATFORM: "https://cloud.menusifudev.com"
    },
    production: {
        SERVER_URL: window.location.origin + "/api",
        PLATFORM: getSubDomain('cloud')
    }
}
function getSubDomain(sub) {
    const { protocol, hostname } = window.location;
    const parts = hostname.split('.');
    parts[0] = sub;
    const newHostname = parts.join('.')
    return `${protocol}//${newHostname}`
}
console.log(process.env.REACT_APP_ENV);
export default ENVs[process.env.REACT_APP_ENV];